/**
 * Include your custom JavaScript here.
 */

window.addEventListener('load', function() {
    if (typeof jQuery === 'undefined') {
        console.warn('jQuery not loaded');
        return;
    }
    var $ = jQuery; // Sicherstellen, dass $ verfügbar ist

    // Preisformatierung — nutzt theme.js Currency (global exponiert)
    var _currencyFormat = (window.theme && window.theme.currencyCodeEnabled && window.theme.moneyWithCurrencyFormat)
      ? window.theme.moneyWithCurrencyFormat
      : (window.theme && window.theme.moneyFormat) ? window.theme.moneyFormat : null;

    function formatPriceCents(cents) {
      if (window.Currency && window.Currency.formatMoney) {
        return window.Currency.formatMoney(cents, _currencyFormat);
      }
      return (cents / 100).toFixed(2).replace(".", ",") + ' &euro;';
    }

    // 1. Sale Icon aus dem versteckten Liquid-Container holen
    var saleIconSource = $("#js-sale-icon-source").html();
    // Fallback, falls das Liquid-Icon nicht gefunden wird
    var fallbackIcon = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" fill="currentColor"><path d="M345 39.1L472.8 168.4c48 48 48 126.4 0 174.4L345 472.9c-29.4 29.4-71.8 39.8-109.9 26.9s-63.5-49.4-63.5-89V160c0-35.3-28.7-64-64-64H16c-8.8 0-16-7.2-16-16V34.9c0-19 21.6-30 36.6-19.6l60.7 42L158 15.4c15-10.4 36.6 .6 36.6 19.6V80h60.4c41.3 0 78.4-22.3 97.5-58.6C361.3 5.4 338.4 4.5 323.8 19.1l-66.2 67.5c-7 7.2-6.3 18.7 .9 25.1c6.9 6.2 17.6 5.8 24.3-1L345 39.1zM32 304c17.7 0 32-14.3 32-32s-14.3-32-32-32s-32 14.3-32 32s14.3 32 32 32z"/></svg>';
    
    // Das finale Icon, das wir verwenden (entweder vom Theme oder Fallback)
    var saleIcon = (saleIconSource && saleIconSource.trim() !== "") ? saleIconSource : fallbackIcon;


    // =====================================================================
    // FIX: .first() verwenden, damit bei Produkten mit compare_at_price
    // nicht mehrere Preis-Elemente konkateniert werden.
    // =====================================================================

    // get basePrice for product or product bundle
    let basePriceContainer;
    let basePriceText;
    let basePrice;

    // product
    if ($("#price").length > 0 || $("[data-money-convertible]").length > 0) {
      basePriceContainer = $("#price, [data-money-convertible]").first();
      basePriceText = basePriceContainer.text();
      basePrice = parseFloat(basePriceText.replace(/[^0-9\-]+/g, ""));
    } else {
      // product bundle with permament sale
      basePriceContainer = $("#basepricesale");
      basePriceText =
        basePriceContainer.length > 0 ? basePriceContainer.text() : "";
      basePrice = parseFloat(basePriceText.replace(/[^0-9\-]+/g, ""));
    }
    
    // 👉 LOGIK 1: Initialer Sale (Produkt ist von Haus aus reduziert)
    if ($("#basepricesale").length > 0) {
        // Farbe setzen
        $("#mobileStickyVariantPrice").css("color", "#f24a00");
        $("#price, #price-adjusted, [data-money-convertible]").css("color", "#f24a00");

        // Layout Umbau für neues Design
        var saleContainer = $("#basepricesale").closest(".ProductMeta__Price__Container");
        var sparenText = saleContainer.find(".Sparen_Preis");
        
        // Prozent aus dem Text extrahieren (falls vorhanden)
        var percentText = sparenText.find("span").text().replace(/[^0-9]/g, '');
        var percent = parseInt(percentText);
        
        if (!isNaN(percent) && percent > 0) {
            
            // A. Badge einfügen (falls noch nicht da)
            if ($("#mengenrabatt-badge").length == 0) {
                var badgeHtml = '<div class="sale-badge-container" id="mengenrabatt-badge">' +
                             '<div class="sale-badge">' +
                                saleIcon + 
                                '<span>-' + percent + '%</span>' +
                             '</div>' +
                           '</div>';
                // Badge ganz oben in die Preisliste einfügen
                $(".ProductMeta__PriceList").prepend(badgeHtml);
            }
            
            // B. Altes "Du sparst" verstecken
            sparenText.hide();
            
            // C. "Statt:" Text hinzufügen
            if (saleContainer.find(".compare-price-text").length == 0) {
                $("#basepricesale").before('<span class="compare-price-text">Statt: </span>');
                $("#basepricesale").addClass("compare-price-value");
                $("#basepricesale").css("text-decoration", "line-through");
            }
        }
    }

    function changeQuantityEvent(_this, type) {
      const selectQuantitySelector = $('.quantitySelect');
      const radioQuantitySelector = $('.custom-qty');
      const opacityClass = 'dimmed';
      
      if (type === 'radio') {
        radioQuantitySelector.removeClass(opacityClass)
        selectQuantitySelector.addClass(opacityClass)
      } else if( type ==='select') {
        selectQuantitySelector.removeClass(opacityClass)
        radioQuantitySelector.addClass(opacityClass)
      }

      
      // =====================================================================
      // FIX: .first() bei der Preis-Lesung, damit nur EIN Element gelesen wird
      // =====================================================================
      if (
        $("[data-money-convertible]").length > 0 &&
        $("[data-money-convertible]").first().attr("id") !== "price-adjusted"
      ) {
        basePriceContainer = $("[data-money-convertible]").first();
        basePriceText = basePriceContainer.text();
        basePrice = parseFloat(basePriceText.replace(/[^0-9\-]+/g, ""));
      }

      var newVal = parseInt(_this.val());

      // =====================================================================
      // FIX: .first() beim Lesen des aktuellen Preises
      // =====================================================================
      var priceText =
        $("#price, [data-money-convertible]").length > 0
          ? $("#price, [data-money-convertible]").first().text()
          : $("#price-adjusted, [data-money-convertible]").length > 0
          ? $("#price-adjusted, [data-money-convertible]").first().text()
          : "";
      var price = parseFloat(priceText.replace(/[^0-9\-]+/g, ""));

      // Update base price if reduced price is available
      var compareAtPrice = $(
        ".ProductMeta__Price .Price--compareAt-mengenrabatt .u-h4"
      );
      if (compareAtPrice.length > 0) {
        basePrice = parseFloat(
          compareAtPrice.first().text().replace(/[^0-9\-]+/g, "")
        );
      }

      // 👉 LOGIK 2a: Sale-Produkt → kein Mengenrabatt, LOGIK 1 hat den Sale-Badge gesetzt
      if ($("#basepricesale").length > 0) {
        // Versandinfo auch bei Sale-Produkten aktualisieren (Gesamtpreis = Preis × Menge)
        updateShippingDisplay(basePrice * newVal);
        return;
      }

      // 👉 LOGIK 2b: Reset wenn Menge wieder 1 ist (nur Produkte OHNE Sale)
      if (newVal === 1 && $("#basepricesale").length == 0) {
        updateShippingDisplay(basePrice);

        $("#pricecontainermengenrabatt").remove();
        $("#compareAtmengenrabatt").remove();
        $("#prozenzt-mengenrabatt1").remove();
        $("#prozenzt-mengenrabatt").remove();
        
        // Badge entfernen
        $("#mengenrabatt-badge").remove();
        
        var formattedStandardPrice = formatPriceCents(basePrice);

        $(
          ".ProductMeta__Price__Container .ProductMeta__Price .Text--subdued .u-h4"
        ).text(basePrice.toFixed(2).replace(".", ","));
        $(
          ".ProductMeta__Price__Container .ProductMeta__Price .Price--highlight .u-h4"
        ).text(basePrice.toFixed(2).replace(".", ","));
        
        if ($("#price-adjusted").length > 0) {
          $("#price-adjusted").attr("id", "price");
        }
        
        // Update Haupt-Preis (Schreiben auf ALLE Elemente ist OK)
        $("#price-adjusted, #price, [data-money-convertible]").html(formattedStandardPrice);
        $("#mobileStickyVariantPrice").html(formattedStandardPrice);

        $("#price-adjusted, #price, [data-money-convertible]").css("color", "");
        $("#mobileStickyVariantPrice").css("color", "");

        return;
      }

      // Apply discount based on quantity selected
      var discount = 0;
      if (newVal == 2) {
        discount = 0.09;
      } else if (newVal >= 3) {
        discount = 0.12;
      }

      // Update price with discount applied
      var discountedPriceRaw = basePrice * (1 - discount);
      var finalPrice = Math.ceil(discountedPriceRaw);

      // Versandinfo: Gesamtpreis = rabattierter Einzelpreis × Menge
      updateShippingDisplay(finalPrice * newVal);
      var compareprice = basePrice / 100;
      var savePercent = Math.round(discount * 100);

      var formattedFinalPrice = formatPriceCents(finalPrice);

      // Update new price text and color (Schreiben auf ALLE ist OK)
      if ($("#price-adjusted, [data-money-convertible]").length > 0 && newVal > 1) {
          $("#price-adjusted, [data-money-convertible]").html(formattedFinalPrice);
          $("#mobileStickyVariantPrice").html(formattedFinalPrice); 

          $("#price-adjusted, [data-money-convertible]").css("color", "#f24a00");
          $("#mobileStickyVariantPrice").css("color", "#f24a00");

      } else if ($("#price, [data-money-convertible]").length > 0 && newVal > 1) {
          $("#price, [data-money-convertible]").html(formattedFinalPrice);
          $("#mobileStickyVariantPrice").html(formattedFinalPrice);

          $("#price, [data-money-convertible]").css("color", "#f24a00");
          $("#mobileStickyVariantPrice").css("color", "#f24a00");
      }

      // 👉 LOGIK 3: Neues HTML Design aufbauen (Badge oben, Statt unten)
      
      // A. Badge vorbereiten (nutzt jetzt die 'saleIcon' Variable von oben)
      var badgeHtml = '<div class="sale-badge-container" id="mengenrabatt-badge">' +
                        '<div class="sale-badge">' +
                           saleIcon + 
                           '<span id="badge-percent">-' + savePercent + '%</span>' +
                        '</div>' +
                      '</div>';

      // Badge einfügen oder updaten
      if ($("#mengenrabatt-badge").length == 0) {
          $(".ProductMeta__PriceList").prepend(badgeHtml);
      } else {
          $("#badge-percent").text('-' + savePercent + '%');
      }

      // B. "Statt"-Container bauen
      if (
        $("#pricecontainermengenrabatt").length == 0 &&
        $("#basepricesale").length == 0
      ) {
        compareAtPriceContainer = $(
          '<div class="ProductMeta__Price__Container compareAt-mengenrabatt" id="pricecontainermengenrabatt">' +
            '<span class="compare-price-text">Statt: </span>' + 
            '<s class="compare-price-value" id="compareAtmengenrabatt">' +
             formatPriceCents(compareprice * 100) +
            '</s>' +
          "</div>"
        );
        
        $(".ProductMeta__PriceList .ProductMeta__Price__Container").last().after(
           compareAtPriceContainer
        );
      } else {
        // Nur den Wert updaten
         $("#compareAtmengenrabatt").html(formatPriceCents(compareprice * 100));
      }

      // Add price-adjusted ID to price container if it doesn't exist
      if ($("#price-adjusted").length === 0) {
        $("#price, [data-money-convertible]").first().attr("id", "price-adjusted");
      }
    }
    
    // quantity selector on product page
    $("#quantityCustomSelector").on("change", function()  {
      changeQuantityEvent($(this),'select');
    });
    $("input[name='qtyCtrl']").on("change", function() {
      changeQuantityEvent($(this), 'radio');
    });  
      
    // quantity selector on product bundle page
    $("#quantityCustomSelectorBundle").on("change", function () {
      
      // 1. Währungssymbol & Locale ermitteln (aus dem Verkaufspreis)
      var symbolElement = $("#pricesale, [data-money-convertible]").first();
      var symbolText = symbolElement.length > 0 ? symbolElement.text() : "";
      var rawSymbol = symbolText.replace(/[0-9\.\-,]+/g, "").trim();
      
      // Sicherheits-Check gegen doppelte Symbole
      var currencySymbol = rawSymbol;
      if (rawSymbol.length > 1 && rawSymbol.charAt(0) === rawSymbol.charAt(1)) {
          currencySymbol = rawSymbol.charAt(0);
      }
      
      function toHtmlEntity(sym) {
        switch (sym) {
          case "€": return "&euro;";
          case "$": return "&dollar;";
          case "£": return "&pound;";
          default: return sym;
        }
      }
      currencySymbol = toHtmlEntity(currencySymbol);

      var locale = "de-DE"; 
      if (currencySymbol === "&dollar;") { locale = "en-US"; }
      else if (currencySymbol === "&pound;") { locale = "en-GB"; }


      // 2. VERKAUFSPREIS behandeln (#pricesale) — .first() für sicheres Lesen
      var sellingElement = $("#pricesale, [data-money-convertible]").first();
      if(sellingElement.length > 0) {
          var sellingText = sellingElement.text();
          var sellingPrice = parseFloat(sellingText.replace(/[^0-9\-]+/g, ""));
          
          // Schreiben wir den Verkaufspreis sauber zurück
          $("#pricesale").html(
            currencySymbol +
            (sellingPrice / 100).toLocaleString(locale, {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
            })
          );

          // Versandinfo für Bundles aktualisieren (Verkaufspreis × Menge)
          var bundleQty = parseInt($("#quantityCustomSelectorBundle").val()) || 1;
          updateShippingDisplay(sellingPrice * bundleQty);
      }


      // 3. STREICHPREIS behandeln (#basepricesale)
      var compareElement = $("#basepricesale");
      if(compareElement.length > 0) {
          var compareText = compareElement.text();
          if(compareText.trim() !== "") {
              var comparePrice = parseFloat(compareText.replace(/[^0-9\-]+/g, ""));

              $("#basepricesale").html(
                currencySymbol +
                (comparePrice / 100).toLocaleString(locale, {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2
                })
              );
          }
      }
    });



    function updateQty(val) {
      $("input[name='quantity']").val(val);
    }

    // Shipping info based on price — dynamisch mit shipping_calculator.js Schwellenwert
    function getShippingThresholdCents() {
      // QUELLE DER WAHRHEIT ist das Shopify-Versandprofil ("General profile",
      // 21 Zonen, 44 Methoden), NICHT die Seite /pages/versand. Nur das Profil
      // bestimmt, was der Kunde im Checkout tatsächlich zahlt.
      //
      // Werte in der kleinsten Einheit der jeweiligen Landeswährung (Cent, Øre,
      // Grosz …), weil der Vergleichswert aus dem DOM-Preis des jeweiligen
      // Marktes kommt.
      //
      // Am 2026-08-11 gegen das Profil abgeglichen, nachdem sieben neue Zonen
      // angelegt wurden (Ungarn, Baltikum & Bulgarien, Estland/Griechenland/
      // Schweden, Finnland, Malta & Zypern, Island, Türkei) und Norwegen,
      // Schweiz, Liechtenstein und Irland neue Freigrenzen bekamen.
      //
      // Deutschland: GLS ist der günstigere der beiden Tarife (2,99 €, frei ab
      // 30 €), DHL liegt bei 3,49 € und frei ab 35 €. Der Kunde sieht den
      // günstigeren, deshalb 30 €.
      //
      // Bei JEDER Änderung alle Stellen anfassen: hier, die Tabelle in
      // assets/shipping_calculator.js (ganze Währungseinheiten), das
      // {% case %} in snippets/cart-drawer.liquid und /pages/versand.
      var country = (window.shopUserCountry || 'DE').toUpperCase();
      var rules = {
        'DE': 3000,
        'AT': 3500, 'NL': 3500, 'BE': 3500, 'LU': 3500, 'HR': 3500, 'HU': 3500,
        'SK': 3500, 'SI': 3500,
        'FR': 4500, 'IT': 4500, 'ES': 4500, 'PT': 4500, 'LV': 4500, 'LT': 4500, 'BG': 4500,
        'EE': 5000, 'GR': 5000,
        'IE': 5900, 'FI': 6500,
        'MT': 9900, 'CY': 9900,
        'CH': 21900, 'LI': 21900,
        'GB': 6500,
        'NO': 273500, 'PL': 17497, 'RO': 25000, 'CZ': 123000, 'DK': 29063
      };
      // SE, HU, IS und TR zahlen im Checkout in SEK, HUF, ISK und TRY, ihre
      // Zone ist aber in Euro ausgepreist. Die Werte hier sind deshalb mit dem
      // EZB-Kurs vom 10.08.2026 umgerechnet und AUFGERUNDET, damit die Anzeige
      // nie zu früh Gratisversand verspricht. Einmal im Jahr nachrechnen.
      // Für HU (12.800 HUF) und IS (53.400 ISK) siehe die Einheiten-Notiz unten.
      rules['SE'] = 54900;      // 549 SEK ~ 50 €
      rules['HU'] = 1280000;    // 12.800 HUF ~ 35 €
      rules['IS'] = 5340000;    // 53.400 ISK ~ 375 €
      rules['TR'] = 1080000;    // 10.800 TRY ~ 195 €
      // EINHEITEN-FALLE bei HUF und ISK: Diese Märkte zeigen Preise ohne
      // Nachkommastellen. Der DOM-Parser unten liefert dort GANZE Forint bzw.
      // Kronen, variant.price dagegen wie immer Hundertstel. Die Werte oben
      // sind in Hundertsteln, der Varianten-Pfad stimmt also; die einmalige
      // Anzeige beim Erstladen liegt in diesen beiden Märkten zu niedrig und
      // zeigt "Versand kostet" statt "Versand frei". Bewusst so gelassen:
      // lieber zu vorsichtig als ein falsches Versprechen.
      //
      // Zone "Rest der Welt" (28 Länder, u. a. USA, Australien, Serbien): 200 €.
      return Object.prototype.hasOwnProperty.call(rules, country) ? rules[country] : 20000;
    }

    function updateShippingDisplay(priceCents) {
      var threshold = getShippingThresholdCents();
      var freeEl = document.querySelector('.js-shipping-free');
      var paidEl = document.querySelector('.js-shipping-paid');
      if (!freeEl && !paidEl) return;

      if (priceCents >= threshold) {
        if (freeEl) freeEl.style.display = '';
        if (paidEl) paidEl.style.display = 'none';
      } else {
        if (freeEl) freeEl.style.display = 'none';
        if (paidEl) paidEl.style.display = '';
      }
    }

    // Initial: Preis aus DOM lesen (pricesale für Bundles, price für normale Produkte)
    var initialPriceEl = jQuery("#pricesale, #price, [data-money-convertible]").first();
    var initialPrice = parseInt(initialPriceEl.text().replace(/[^0-9\-]+/g, "")) || 0;
    updateShippingDisplay(initialPrice);

    document.addEventListener("variant:changed", function (event) {
        const variant = event.detail.variant;
        if (!variant) return;


        // 1. Technischen Wert für den Warenkorb setzen
        const mainVariantSelector = document.querySelector("select[name='id']");
        if (mainVariantSelector) mainVariantSelector.value = variant.id;

        // 2. Basispreis für Mengenrabatt-Skript aktualisieren
        // WICHTIG: basePrice muss global verfügbar sein
        window.basePrice = variant.price;

        // 2b. Versandinfo aktualisieren
        updateShippingDisplay(variant.price); 

        // 3. Warenkorb-Button Status (Enable/Disable)
        const atcBtn = document.querySelector('[data-action="add-to-cart"]');
        if (atcBtn) {
            if (variant.available) {
                atcBtn.disabled = false;
                var atcSpan = atcBtn.querySelector('span') || atcBtn;
                atcSpan.textContent = window.languages && window.languages.productFormAddToCart ? window.languages.productFormAddToCart : "In den Warenkorb";
            } else {
                atcBtn.disabled = true;
                var atcSpan = atcBtn.querySelector('span') || atcBtn;
                atcSpan.textContent = window.languages && window.languages.productFormSoldOut ? window.languages.productFormSoldOut : "Ausverkauft";
            }
        }

        // 4. PREIS-AKTUALISIERUNG ERZWINGEN
        // Wir triggern manuell die Mengen-Berechnung neu, damit das Skript
        // den neuen Preis der Variante nimmt und den Rabatt (9% / 12%) neu rechnet.
        setTimeout(function() {
            const qtySelector = document.getElementById("quantityCustomSelector") || 
                                document.getElementById("quantityCustomSelectorBundle") ||
                                document.querySelector("input[name='qtyCtrl']:checked");
            
            if (qtySelector) {
                console.log("Triggere Mengenrabatt-Neuberechnung für neue Variante...");
                // Wir nutzen jQuery, da dein custom.js darauf basiert
                if (window.jQuery) {
                    $(qtySelector).trigger('change');
                } else {
                    qtySelector.dispatchEvent(new Event("change", { bubbles: true }));
                }
            }
        }, 100); // Kurze Verzögerung, damit theme.js mit dem DOM-Umbau fertig ist
    });

    function updateCartCount() {
      if (!window.Shopify || !window.Shopify.routes) return;
      fetch(window.Shopify.routes.root + "cart.js")
        .then(function(response) { return response.json(); })
        .then(function(data) {
          var cartCountEls = document.querySelectorAll('.Header__CartCount');
          cartCountEls.forEach(function(el) { el.textContent = data.item_count; });
          var cartDots = document.querySelectorAll('.Header__CartDot');
          cartDots.forEach(function(el) {
            el.textContent = data.item_count;
            el.classList.toggle('is-visible', data.item_count > 0);
          });
        })
        .catch(function(err) { console.error('Cart fetch error:', err); });
    }

    const quantityChanger = $('[data-action="update-item-quantity"]');
    quantityChanger.on("click", function () {
      updateCartCount();
    });

    const quantitySelector = $(".QuantitySelector__CurrentQuantity");
    quantityChanger.on("change", function () {
      updateCartCount();
    });

    document.addEventListener("product:added", function (event) {
      updateCartCount();
    });

    document.addEventListener("cart:refresh", function (event) {
      updateCartCount();
    });

    // Klavyio out of stock trigger
    $(document).on("click", ".klaviyo-bis-trigger", function () {
      window._klOnsite = window._klOnsite || [];
      window._klOnsite.push(["openForm", "SVdrDW"]);
    });


    
  },
  false
);

document.addEventListener('DOMContentLoaded', function () {
  const variantSelect = document.getElementById('variant-select');
  const deliveryTime = document.getElementById('delivery-time');

  if (!variantSelect || !deliveryTime) return;

  // Funktion, um das Metafield zu aktualisieren
  const updateDeliveryTime = () => {
    const selectedOption = variantSelect.options[variantSelect.selectedIndex];
    const deliveryTimeValue = selectedOption.getAttribute('data-delivery-time');

    deliveryTime.textContent = deliveryTimeValue || 'unbekannt';
  };

  // Event-Listener für Variantenwechsel
  variantSelect.addEventListener('change', updateDeliveryTime);

  // Initiale Anzeige beim Laden der Seite
  updateDeliveryTime();
});

// Contact-Form Tracking — injiziert Hidden Inputs in jedes /contact-Form (Theme, PageFly, beliebig).
// Werte stammen aus First-Party-Cookies + Browser-Context und gehen mit der Shopify-Notification-Mail mit.
(function () {
  function getCookie(name) {
    var m = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
    return m ? decodeURIComponent(m[2]) : '';
  }
  function resolve(key) {
    switch (key) {
      case 'ga_client_id':
        var ga = getCookie('_ga');
        return ga ? ga.split('.').slice(-2).join('.') : '';
      case 'gclid':        return getCookie('gclid') || getCookie('bh_gclid');
      case 'fbp':          return getCookie('_fbp');
      case 'fbc':          return getCookie('__fbc') || getCookie('_fbc');
      case 'fbadid':       return getCookie('_mk_fbadid');
      case 'ttclid':       return getCookie('_ttp');
      case 'msclkid':      return getCookie('_uetmsclkid');
      case 'utm_source':   return getCookie('bh_utm_source');
      case 'utm_medium':   return getCookie('bh_utm_medium');
      case 'utm_campaign': return getCookie('bh_utm_campaign');
      case 'utm_term':     return getCookie('bh_utm_term');
      case 'utm_content':  return getCookie('bh_utm_content');
      case 'page_url':     return window.location.href;
      case 'referrer':     return document.referrer || '';
      default:             return '';
    }
  }
  var KEYS = [
    'ga_client_id', 'gclid', 'fbp', 'fbc', 'fbadid', 'ttclid', 'msclkid',
    'utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content',
    'page_url', 'referrer'
  ];
  function inject(form) {
    if (form.dataset.bhTracking) return;
    form.dataset.bhTracking = '1';
    KEYS.forEach(function (k) {
      if (form.querySelector('input[name="contact[' + k + ']"]')) return;
      var i = document.createElement('input');
      i.type = 'hidden';
      i.name = 'contact[' + k + ']';
      i.value = resolve(k);
      form.appendChild(i);
    });
  }
  function refresh(form) {
    KEYS.forEach(function (k) {
      var el = form.querySelector('input[name="contact[' + k + ']"]');
      if (el) el.value = resolve(k);
    });
  }
  function scan() {
    document.querySelectorAll('form[action*="/contact"]').forEach(inject);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scan);
  } else {
    scan();
  }
  // Re-fill direkt vor Submit (frische Werte, falls Cookies während Tippen aktualisiert wurden)
  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (f && f.action && f.action.indexOf('/contact') !== -1) {
      inject(f);
      refresh(f);
    }
  }, true);
})();